import { FormTemplateData } from "src/app/services/response-models/form-templates.response.model";

export class LoadSelectedFormTemplate {
    public static readonly type = "[Form Templates] Load selected form template";

    constructor(public payload: FormTemplateData) {}
}
